module.exports = __webpack_public_path__ + "static/media/warning.c433cf01.png";